module.exports = __webpack_public_path__ + "img/sectional.3f86916.svg";